import './styles/main.scss'
import React from 'react'
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Route, Router } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import Promise from 'promise-polyfill'; 
import Main from './routes/Main';

// add two methods three older browser (e.g. IE 11)
if (!window.Promise) {
  window.Promise = Promise;
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(searchString, position) {
      position = position || 0;
      return this.substr(position, searchString.length) === searchString;
  };
}

Number.isInteger = Number.isInteger || ( value => typeof value === "number" && isFinite(value) && Math.floor(value) === value);


if (!Array.prototype.find) {
  Array.prototype.find = function(predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    const list = Object(this);
    const length = list.length >>> 0;
    const thisArg = arguments[1];    

    for (let i = 0; i < length; i++) {
      let value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

const App = ({history, store}) => (
    <Provider store={store}>
      <ConnectedRouter history={history}>
          <Main/>          
        </ConnectedRouter>
    </Provider>
);

App.propTypes = {
    history: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired
};

export default App;